export default {
      id: "icon-pin-usage",
      viewBox: "0 0 16 20",
      url: "../icon/" + "icons.svg#icon-pin-usage",
      toString: function () {
        return this.url;
      }
    }